export default __webpack_public_path__ + "static/media/image 17.d953c070.png";